"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberInput = void 0;
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var hooks_1 = require("../../../mantine-hooks/src");
var theme_1 = require("../../../mantine-theme/src");
var TextInput_1 = require("../TextInput/TextInput");
var NumberInput_styles_1 = __importStar(require("./NumberInput.styles"));
function NumberInput(_a) {
    var disabled = _a.disabled, themeOverride = _a.themeOverride, elementRef = _a.elementRef, value = _a.value, onChange = _a.onChange, min = _a.min, max = _a.max, _b = _a.step, step = _b === void 0 ? 1 : _b, onBlur = _a.onBlur, onFocus = _a.onFocus, _c = _a.hideControls, hideControls = _c === void 0 ? false : _c, _d = _a.radius, radius = _d === void 0 ? 'sm' : _d, variant = _a.variant, _e = _a.precision, precision = _e === void 0 ? 0 : _e, defaultValue = _a.defaultValue, _f = _a.noClampOnBlur, noClampOnBlur = _f === void 0 ? false : _f, others = __rest(_a, ["disabled", "themeOverride", "elementRef", "value", "onChange", "min", "max", "step", "onBlur", "onFocus", "hideControls", "radius", "variant", "precision", "defaultValue", "noClampOnBlur"]);
    var theme = theme_1.useMantineTheme(themeOverride);
    var classes = NumberInput_styles_1.default({ theme: theme, radius: radius });
    var _g = react_1.useState(false), focused = _g[0], setFocused = _g[1];
    var _h = react_1.useState(typeof value === 'number' ? value : typeof defaultValue === 'number' ? defaultValue : 0), _value = _h[0], setValue = _h[1];
    var finalValue = typeof value === 'number' ? value : _value;
    var _j = react_1.useState(typeof finalValue === 'number' ? finalValue.toFixed(precision) : ''), tempValue = _j[0], setTempValue = _j[1];
    var inputRef = react_1.useRef();
    var handleValueChange = function (val) {
        // console.log(val);
        typeof onChange === 'function' && onChange(val);
        setValue(val);
    };
    var _min = typeof min === 'number' ? min : -Infinity;
    var _max = typeof max === 'number' ? max : Infinity;
    var clamp = function (v) {
        var val = typeof v === 'number' ? v : parseFloat(v);
        return Math.min(Math.max(val, _min), _max);
    };
    react_1.useEffect(function () {
        if (typeof value === 'number' && !focused) {
            setValue(value);
            setTempValue(value.toFixed(precision));
        }
    }, [value]);
    var rightSection = (react_1.default.createElement("div", { className: classes.rightSection },
        react_1.default.createElement("button", { type: "button", tabIndex: -1, "aria-hidden": true, "data-mantine-increment": true, onMouseDown: function (event) {
                event.preventDefault();
                var result = clamp(finalValue + step).toFixed(precision);
                handleValueChange(parseFloat(result));
                setTempValue(result);
                inputRef.current.focus();
            }, disabled: finalValue >= max, className: clsx_1.default(classes.control, classes.controlUp) }),
        react_1.default.createElement("button", { type: "button", tabIndex: -1, "aria-hidden": true, "data-mantine-decrement": true, onMouseDown: function (event) {
                event.preventDefault();
                var result = clamp(finalValue - step).toFixed(precision);
                handleValueChange(parseFloat(result));
                setTempValue(result);
                inputRef.current.focus();
            }, disabled: finalValue <= min, className: clsx_1.default(classes.control, classes.controlDown) })));
    var handleChange = function (event) {
        var val = event.currentTarget.value;
        setTempValue(val);
        var parsed = Number(val);
        val.trim() !== '' && !Number.isNaN(parsed) && handleValueChange(parsed);
    };
    var handleBlur = function (event) {
        var val = clamp(event.currentTarget.value);
        if (!Number.isNaN(val)) {
            if (!noClampOnBlur) {
                setTempValue(val.toFixed(precision));
                handleValueChange(val);
            }
        }
        else {
            setTempValue(finalValue.toFixed(precision));
        }
        setFocused(false);
        typeof onBlur === 'function' && onBlur(event);
    };
    var handleFocus = function (event) {
        setFocused(true);
        typeof onFocus === 'function' && onBlur(event);
    };
    return (react_1.default.createElement(TextInput_1.TextInput, __assign({}, others, { variant: variant, value: tempValue, disabled: disabled, themeOverride: themeOverride, elementRef: hooks_1.useMergedRef(inputRef, elementRef), type: "number", onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, rightSection: disabled || hideControls || variant === 'unstyled' ? null : rightSection, rightSectionWidth: NumberInput_styles_1.CONTROL_WIDTH + 1, radius: radius, max: max, min: min, step: step })));
}
exports.NumberInput = NumberInput;
NumberInput.displayName = '@mantine/core/NumberInput';
